<template>
    <div
        class="youtube aspect-video w-full"
        @click="onLoadVideo"
    >
        <div>
            <v-lazy-image
                v-if="!isLoadVideo"
                :src="video.getThumbnailSrc()"
            />

            <div
                v-text="video.title"
                class="absolute bottom-0 w-full truncate bg-gradient-to-t from-void via-void/80 to-transparent px-3 pb-2 pt-8 text-center text-xs tracking-[0.04em] text-foam/90"
            />
        </div>

        <div
            v-if="!isLoadVideo"
            class="play-button"
            @click="onLoadVideo"
        />

        <template v-if="isLoadVideo">
            <iframe
                :src="`https://www.youtube.com/embed/${video.id}?&autoplay=1&enablejsapi=1`"
                title="YouTube video player"
                allowfullscreen
            />
        </template>
    </div>
</template>

<script>
    // Models
    // Library
    import { defineComponent, ref } from 'vue';
    import VLazyImage from 'v-lazy-image';
    import Video from '@/models/Video.model';

    export default defineComponent({
        name: 'YoutubePlayer',
        // TODO: Use youtube iFrame api https://developers.google.com/youtube/iframe_api_reference

        components: {
            VLazyImage,
        },

        props: {
            video: {
                type: Video,
                required: true,
            },
        },

        setup(props, { emit }) {
            const isLoadVideo = ref(false);

            const onLoadVideo = () => {
                isLoadVideo.value = true;

                emit('loadVideo');
            };

            return {
                isLoadVideo,
                onLoadVideo,
            };
        },
    });
</script>

<style>
    .youtube {
        background-color: oklch(0.08 0.02 255);
        position: relative;
        overflow: hidden;
    }

    .youtube img {
        width: 100%;
        top: -16.82%;
        left: 0;
        opacity: 0.7;
    }

    .youtube .play-button {
        width: 22%;
        max-width: 74px;
        aspect-ratio: 1;
        background-color: oklch(0.01 0.01 260 / 45%);
        border: 1px solid oklch(0.91 0.01 240 / 45%);
        border-radius: 50%;
        backdrop-filter: blur(4px);
        z-index: 1;
        opacity: 0.85;
        transition: opacity 0.2s ease, border-color 0.2s ease;
    }

    .youtube .play-button:hover {
        opacity: 1;
        border-color: oklch(0.91 0.01 240 / 90%);
    }

    .youtube .play-button:before {
        content: '';
        border-style: solid;
        border-width: 11px 0 11px 19px;
        border-color: transparent transparent transparent oklch(0.91 0.01 240);
        margin-left: 3px;
    }

    .youtube,
    .youtube img,
    .youtube .play-button {
        cursor: pointer;
    }

    .youtube img,
    .youtube iframe,
    .youtube .play-button,
    .youtube .play-button:before {
        position: absolute;
    }

    .youtube .play-button,
    .youtube .play-button:before {
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        z-index: 0;
    }

    .youtube iframe {
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
    }
</style>
